import request from '@/utils/request'

// 查询离职申请列表
export function listDepart(query) {
    return request({
        url: '/bpm/depart/findAll',
        method: 'post',
        data: query
    })
}
// 查询转正申请详细
export function initApply() {
    return request({
        url: '/bpm/depart/initApply',
        method: 'get'
    })
}

// 修改转正申请
export function completeTask(data) {
    return request({
        url: '/bpm/depart/completeTask',
        method: 'post',
        data: data
    })
}
// 查询离职申请详细
export function getDepart(id) {
    return request({
        url: '/bpm/depart/findOne?id=' + id,
        method: 'post'
    })
}

export function getByProcessInstanceId(processInstanceId) {
    return request({
        url: '/bpm/depart/getByProcessInstanceId?processInstanceId=' + processInstanceId,
        method: 'post'
    })
}

// 新增离职申请
export function addDepart(data) {
    return request({
        url: '/bpm/depart/add',
        method: 'post',
        data: data
    })
}

// // 修改离职申请
// export function updateDepart(data) {
//     return request({
//         url: '/bpm/depart/edit',
//         method: 'post',
//         data: data
//     })
// }

// 删除离职申请
export function delDepart(id) {
    return request({
        url: '/bpm/depart/remove',
        method: 'post',
        data: id
    })
}

// 导出离职申请
export function exportDepart(query) {
    return request({
        url: '/bpm/depart/export',
        method: 'post',
        data: query
    })
}
